
import NsHeaderTop from "./NsHeaderTop";
import NsHeaderMid from "./NsHeaderMid";
import { tree } from "@/api/goods/goodscategory";
import { navList } from "@/api/website";
export default {
  props: {
    forceExpand: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShopHover: false,
      isIndex: false,
      thisRoute: "",
      goodsCategoryTree: [],
      selectedCategory: -1,
      navList: [],
      navSelect: ""
    };
  },
  components: {
    NsHeaderTop,
    NsHeaderMid
  },
  computed: {},
  beforeCreate() {},
  created() {
    this.$store.dispatch("cart/cart_count");
    this.$store.dispatch("wholesaleCart/cart_count")
    this.getTree();
    this.nav();
    if (this.$route.path == "/" || this.$route.path == "/index")
      this.isIndex = true;
  },
  mounted() {},
  watch: {
    $route: function(curr) {
      this.initNav(curr.path);
      if (curr.path == "/" || curr.path == "/index") this.isIndex = true;
      else this.isIndex = false;

      if (curr.path == "/list") {
        this.navSelect = ""
      }
    }
  },
  methods: {
    getTree() {
      tree({
        level: 3,
        template: 2
      })
        .then(res => {
          if (res.code == 0 && res.data) {
            this.goodsCategoryTree = res.data;
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    nav() {
      navList({})
        .then(res => {
          if (res.code == 0 && res.data) {
            this.navList = res.data.list;
            for (let i in this.navList) {
              this.navList[i]["url"] = JSON.parse(
                this.navList[i]["nav_url"]
              ).url;
            }
            this.initNav(this.$route.path);
          }
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    navUrl(url, target) {
      if (!url) return;
      if (url.indexOf("http") == -1) {
        if (target) this.$router.pushToTab({ path: url });
        else this.$router.push({ path: url });
      } else {
        if (target) window.open(url);
        else window.location.href = url;
      }
    },
    initNav(path) {
      for (let i in this.navList) {
        if (this.navList[i]["url"] == path) {
          this.navSelect = path;
          continue;
        }
      }
    },
    //鼠標移入顯示商品分類
    shopHover() {
      this.isShopHover = true;
    },
    //鼠標移出商品分類隱藏
    shopLeave() {
      this.isShopHover = false;
    }
  }
};
